import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";

function CustomTick({ x, y, value, range }) {
    const d = value instanceof Date ? value : new Date(value);

    let label;
    if (["1S", "3S", "6S", "12S", "1G"].includes(range)) {
        label = d.toLocaleTimeString("tr-TR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "Europe/Istanbul",
        });
    } else {
        label = d.toLocaleDateString("tr-TR", {
            day: "2-digit",
            month: "short",
            timeZone: "Europe/Istanbul",
        });
    }

    return (
        <text x={x} y={y} textAnchor="middle" fontSize={11} fill="#444">
            {label}
        </text>
    );
}

export default function CapacitivePowerChart({ data, range, onRangeChange, deviceType }) {
    const now = new Date();
    const showMarks = ["1S", "3S"].includes(range);

    let min;
    switch (range) {
        case "1S": min = new Date(now.getTime() - 1 * 60 * 60 * 1000); break;
        case "3S": min = new Date(now.getTime() - 3 * 60 * 60 * 1000); break;
        case "6S": min = new Date(now.getTime() - 6 * 60 * 60 * 1000); break;
        case "12S": min = new Date(now.getTime() - 12 * 60 * 60 * 1000); break;
        case "1G": min = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000); break;
        case "3G": min = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000); break;
        case "1H": min = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000); break;
        default: min = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    }
    const max = now;

    return (
        <div>
            {/* Filtre Butonları */}
            <div className="flex flex-wrap gap-2 mb-4 justify-center md:justify-start">
                {[
                    { key: "1S", label: "1 Saat" },
                    { key: "3S", label: "3 Saat" },
                    { key: "6S", label: "6 Saat" },
                    { key: "12S", label: "12 Saat" },
                    { key: "1G", label: "1 Gün" },
                    { key: "3G", label: "3 Gün" },
                    { key: "1H", label: "1 Hafta" },
                ].map((r) => (
                    <button
                        key={r.key}
                        onClick={() => onRangeChange(r.key)}
                        className={`px-3 py-2 rounded-md border text-sm font-medium transition
              ${range === r.key
                                ? "bg-red-600 text-white border-red-600"
                                : "bg-white text-gray-800 border-gray-300 hover:bg-gray-100"}`}
                    >
                        {r.label}
                    </button>
                ))}
            </div>

            <LineChart
                dataset={data}
                xAxis={[
                    {
                        dataKey: "time",
                        scaleType: "time",
                        position: "bottom",
                        min: min.getTime(),
                        max: max.getTime(),
                        tickNumber: 8,
                        tickLabel: (props) => <CustomTick {...props} range={range} />,
                        valueFormatter: (value) => {
                            const d = value instanceof Date ? value : new Date(value);
                            if (["1S", "3S", "6S", "12S", "1G"].includes(range)) {
                                return d.toLocaleTimeString("tr-TR", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                    timeZone: "Europe/Istanbul",
                                });
                            } else {
                                return d.toLocaleDateString("tr-TR", {
                                    day: "2-digit",
                                    month: "short",
                                    timeZone: "Europe/Istanbul",
                                });
                            }
                        },
                    },
                ]}

                series={[
                    { dataKey: "QC1", label: "L1 Kapasitif Güç", color: "#ec4899", showLine: true, showMark: showMarks },
                    { dataKey: "QC2", label: "L2 Kapasitif Güç", color: "#3b82f6", showLine: true, showMark: showMarks },
                    { dataKey: "QC3", label: "L3 Kapasitif Güç", color: "#06b6d4", showLine: true, showMark: showMarks },
                ]}

                height={350}
                axisHighlight={{ x: "line" }}
                slotProps={{
                    legend: {
                        direction: 'row',
                        position: { vertical: 'top', horizontal: 'middle' },
                        padding: 0,
                    },
                    tooltip: { trigger: "axis" },
                }}
            />
        </div>
    );
}
